import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { DropdownItemComponent } from '../../../components/dropdown/dropdown-item.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { Account, AccountPerformanceGroup, PerformanceGroup, SingleAccountGroup } from '../../../domain/public-api';

@Component({
  selector: 'td-wb-accounts-performance-account-group-dropdown',
  templateUrl: 'account-performance-group-selector.component.html',
  styleUrls: ['account-performance-group-selector.component.scss'],
  imports: [
    DropdownComponent,
    FormsModule,
    TranslatePipe,
    TranslateDirective,
    DropdownItemComponent,
    SlicePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountPerformanceGroupSelectorComponent implements OnChanges {
  @Input() account: Account;
  @Input() accountPerformanceGroups: Array<AccountPerformanceGroup>;
  @Input() accountPerformanceGroup: AccountPerformanceGroup | SingleAccountGroup;

  @Output() accountGroupChange: EventEmitter<SingleAccountGroup | AccountPerformanceGroup>
    = new EventEmitter<SingleAccountGroup | AccountPerformanceGroup>();

  accountGroupObject: { name: SingleAccountGroup };

  performanceGroup: { name: SingleAccountGroup } | AccountPerformanceGroup;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.account !== undefined && changes.account.currentValue !== undefined) {
      this.accountGroupObject = { name : PerformanceGroup.DEFAULT };
      this.performanceGroup = this.accountGroupObject;
    }
    if (changes.accountPerformanceGroup !== undefined && changes.accountPerformanceGroup.currentValue !== undefined) {
      if (changes.accountPerformanceGroup.currentValue === PerformanceGroup.DEFAULT) {
        this.performanceGroup = this.accountGroupObject;
      } else {
        this.performanceGroup = changes.accountPerformanceGroup.currentValue;
      }
    }
  }

  onPerformanceGroupChange(): void {
    if (this.performanceGroup.name === PerformanceGroup.DEFAULT) {
      this.accountGroupChange.emit(this.performanceGroup.name as SingleAccountGroup);
    } else {
      this.accountGroupChange.emit(this.performanceGroup as AccountPerformanceGroup);
    }
  }

  isDisabled(): boolean {
    return this.accountPerformanceGroups.length === 0;
  }
}
